export default "__VITE_ASSET__DgZKqMUu__"